import { z } from "zod";

export const ApiErrorCodeSchema = z.enum([
  "CLIENT_VERSION_UNSUPPORTED",
  "BAD_REQUEST",
  "UNAUTHORIZED",
  "FORBIDDEN",
  "NOT_FOUND",
  "CONFLICT",
  "SYNC_CURSOR_EXPIRED",
  "SYNC_QUOTA_EXCEEDED",
  "RATE_LIMITED",
  "INTERNAL_ERROR",
  "SERVICE_UNAVAILABLE",
  "UPSTREAM_ERROR",
  "UPSTREAM_TIMEOUT",
]);

export const ApiErrorSchema = z.object({
  error: z.object({
    code: ApiErrorCodeSchema,
    message: z.string().min(1),
    requestId: z.string().min(1),
    details: z.record(z.string(), z.unknown()).optional(),
  }),
});

export type ApiErrorCode = z.infer<typeof ApiErrorCodeSchema>;
export type ApiError = z.infer<typeof ApiErrorSchema>;
